import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6e38796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "f" }
const _hoisted_2 = { class: "detail-head flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "table-thead" }
const _hoisted_9 = ["width"]
const _hoisted_10 = { class: "table-body" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_16 = { class: "flex-bwn mb_5" }
const _hoisted_17 = { class: "flex-bwn mb_5" }
const _hoisted_18 = { class: "flex-bwn mb_5" }
const _hoisted_19 = { class: "flex-bwn mb_5" }
const _hoisted_20 = { class: "flex-bwn mb_5" }
const _hoisted_21 = { class: "flex-bwn mb_5" }
const _hoisted_22 = { style: {"max-width":"50%"} }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, watch } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, setFixed2 } from './data'
import { BASE_IMAGE } from '@/common/baseImage'
import { isMultiStore, isJA } from '@/store'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {

const props = __props

// 当前币种对应的单位
const currencyCodeUnit = computed(() => {
  return showCurrentUnit(isMultiStore() && props.rowItemDetail?.currencyCode === 'KRW')
})

const columns = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'productTitle', label: t('商品名称'), width: 180 },
  { prop: 'allPrice', label: t('全包价'), width: 100 },
  { prop: 'feeDetail', label: t('全包价明细'), width: 260 },
  { prop: 'orderQuantity', label: t('下单数量'), width: 100 },
  { prop: 'totalPrice', label: t('支付总金额'), width: 110 }
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderNo ?? ''), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('支付总金额')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.changeAmount), 1)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(currencyCodeUnit)), 1)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", _hoisted_8, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createElementVNode("th", {
                key: item.prop,
                width: item.width
              }, _toDisplayString(item.label), 9, _hoisted_9)
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList || []), (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.productSku
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (v) => {
                return _createElementVNode("td", {
                  key: v.prop
                }, [
                  (v.prop === 'productPropertiesName')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((row[v.prop] || '').split(';'), (prop) => {
                        return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                      }), 128))
                    : (v.prop === 'productImg')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          referrerPolicy: "no-referrer",
                          src: row[v.prop],
                          alt: "",
                          style: {"width":"60px"}
                        }, null, 8, _hoisted_11))
                      : (v.prop === 'allPrice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createTextVNode(_toDisplayString(row.allIncludeProductPriceExchange) + "円", 1),
                            _hoisted_13,
                            _createTextVNode("（" + _toDisplayString(row.allIncludeProductPrice) + "元） ", 1)
                          ]))
                        : (v.prop === 'feeDetail')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (row.allIncludeType === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " - "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('商品代金')) + "： ", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.productPriceExchange) + "円 （" + _toDisplayString(row.actualProductSellPrice) + "元） ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('商品附加项')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.productAdditionPriceExchange) + "円 （" + _toDisplayString(row.productAdditionPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('手续费')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.defaultAdditionPriceExchange) + "円 （" + _toDisplayString(row.defaultAdditionPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('国内运费')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.innerShipPriceExchange) + "円 （" + _toDisplayString(row.innerShipSinglePrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('国际物流费用')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.allIncludeShipPriceExchange) + "円 （" + _toDisplayString(row.allIncludeShipPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('关税1')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.allIncludeTaxPriceExchange) + "円 （" + _toDisplayString(row.allIncludeTaxPrice) + "元）", 1)
                                    ])
                                  ]))
                            ], 64))
                          : (v.prop === 'totalPrice')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                _createTextVNode(_toDisplayString(row.allIncludeProductTotalPriceExchange) + "円", 1),
                                _hoisted_24,
                                _createTextVNode("（" + _toDisplayString(row.allIncludeProductTotalPrice) + "元）", 1)
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(row[v.prop]), 1)
                              ], 64))
                ])
              }), 64))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})